import { QueryClient, useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useContext, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { Loader } from "rizzui/loader";
import { AuthContext } from "../../context/authContext";
import axios from "axios";
import { baseUrl } from "../account/login";
import { useNotifcication } from "../../hooks/useNotification";
import PopUp from "../../component/popUp";

export default function ConnectCalendar() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const navigate = useNavigate();
  const { openNotification } = useNotifcication();
  const queryClient = useQueryClient();

  const connectCalendar = () => {
    return axios
      .get(`${baseUrl}/calendar/google/callback?code=${code}`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        if (response?.data?.success) {
          queryClient.invalidateQueries({
            queryKey: ["user_calendars", token],
          });
          openNotification({
            status: "success",
            message: "Calendar Connected",
          });
          setTimeout(window.close, 2000);
        }

        return response;
      })
      .catch((e) => {
        if (e?.response?.data?.statusCode === 401) navigate("/account/logout");
        else {
          openNotification({
            status: "error",
            message: "Calendar Not Connected",
          });
          setTimeout(window.close, 2000);
        }
        return e;
      });
  };

  const {
    isLoading: callLoading,
    error: callError,
    data: response,
    refetch,
  } = useQuery({
    queryKey: ["connect_calendar", token, code],
    queryFn: () => connectCalendar(),
    enabled: false,
    retry: 0,
  });

  useEffect(() => {
    refetch();
  }, [code]);

  return (
    <div className="h-dvh w-full flex justify-center items-center">
      <PopUp />
      <Loader />
    </div>
  );
}
